import { observable } from 'mobx'

class GameLibraryStore {
  @observable
  /** 当前游戏库列表选择的游戏 */
  currentGameLibraryGame: GameLibraryGame | null = null
  @observable
  /** 默认选中游戏版本 */
  defaultGameVersionMap: Record<string, { gameVersionNo: string }> | null = null
  @observable
  /** 当前游戏库详情的缓存 */
  currentGameStartInfo: Tools.KeyValueProp<GameDetailByLibrary> = {}
  @observable
  /** 当前游戏运行状态 */
  gameRunStatus: 'stop' | 'starting' | 'running' | 'waitClose' = 'stop'

  @observable
  /** 当前正在运行的游戏 */
  currentTheRunningGameInfo: (GameStartPayload & { startGameOrderNo: string; gameStartTime: number }) | null = null

  @observable
  /** 当前正准备启动的游戏 */
  currentTheStartingGameInfo: GameStartPayload | null = null

  @observable
  gameStartingTimer: number | null = null

  /** 是否需要重新加载游戏启动信息 */
  @observable
  refreshGameStartInfo: number = 0

  /** 当前等待上一个游戏结束之后要启动的游戏 */
  @observable
  willStartGameId?: string | number | null = null
}

export default new GameLibraryStore()
